//Specific JS for this skin
require(['jquery'], function ($) {
    let initModal = false;

    const bodyMutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.target.className.includes('modal-open') && $('#PlantStatus').is(":visible")) {
                if (!initModal) {
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop.fade.in').remove();
                    $('#PlantStatus').hide();
                    initModal = true;
                }
            }
        });
    });

    bodyMutationObserver.observe(document.querySelector('body'), { attributes: true });

    $('.PlantStatus-Link').click(function () {
        $('body').addClass('modal-open');
        $('body').append('<div class="modal-backdrop fade in"></div>');
        $('#PlantStatus').show().addClass('in');
    });

    $('#PlantStatus, #PlantStatus button.close, .modal-backdrop.fade.in').click(function () {
        $('body').removeClass('modal-open');
        $('.modal-backdrop.fade.in').remove();
        $('#PlantStatus').hide();
    });
});


